import { useEffect, useState } from "react";
import { getLocale, useSelector, shallowEqual } from "umi";
import moment from 'moment';
import { LANGUAGE_MAP } from '@/pages/dashboard/_config/constant';
import { getApiData } from "@/pages/dashboard/services/common";

const useData = (config: any, formValue: any, filterLoading: boolean, trackDays: string[], accumulated: string[], paramsFilter: Function, dispatch: Function, setPaging: Function, setSorts: Function) => {
  const { api } = config;
  const { tableApi } = api || {};
  const gameCode = useSelector((state: any) => state?.dashboard?.currentGame?.game_code, shallowEqual);
  const [componentData, setComponentData] = useState({
    Rows: [],
    level_count: 0,
    page: 1,
    page_size: 10,
    row_count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  // 点击筛选器的时候
  useEffect(() => {
    if (!formValue) return;
    setPaging({ pageIndex: 1, pageSize: 10 });
    setSorts([]);
    !filterLoading && getRetentionDataFunc(accumulated, [], { pageIndex: 1, pageSize: 10 }, trackDays);
  }, [formValue]);

  const getRetentionDataFunc = (accumulated: string | string[], sort: string | any[], paging: { pageIndex: any; pageSize: any; }, trackDays: string[]) => {
    const { rangeTime, channel, system, zone, lang: language } = formValue;
    const accumulation = {
      by_zone: accumulated.includes('zone'),
      by_region: accumulated.includes('region'),
      by_country: accumulated.includes('country'),
      by_channel: accumulated.includes('channel'),
      by_system: accumulated.includes('system'),
      by_language: accumulated.includes('language'),
      by_bundle: accumulated.includes('bundle'),
    };
    const desc = sort?.length > 0 && sort?.[0] ? sort?.[0]?.order === 'desc' : true;
    const sorted_by = sort?.length > 0 ? sort[0]?.code : 'date';
    // markets筛选器不存在的时候不传markets，存在的时候传[]
    const marketList = formValue?.region?.markets;
    const params = paramsFilter({
      game_code: gameCode,
      filters: {
        market_list: marketList,
        channel_list: channel,
        os_list: system,
        zone_list: zone,
        lang_list: language,
        bundle_list: formValue?.bundle,
      },
      start_time: moment(rangeTime?.[0]).format('YYYY-MM-DD'),
      end_time: moment(rangeTime?.[1]).format('YYYY-MM-DD'),
      track_days: trackDays,
      accumulation,
      period: 'daily',
      desc,
      sorted_by,
      page: paging?.pageIndex,
      page_size: paging?.pageSize,
    });
    setLoading(true);
    const locale = LANGUAGE_MAP[getLocale()];
    getApiData(`${tableApi}?language=${locale}`, params).then((result: any) => {
      setLoading(false);
      setError(false);
      setComponentData(result);
      dispatch({
        type: "engagementServiceData/getRetentionDataFunc",
        payload: {
          result
        }
      });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }).catch((err: any) => {
      setError(true);
      setLoading(false);
    });
  };
  return {
    componentData,
    getRetentionDataFunc,
    loading,
    error,
  };
};

export default useData;